import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'mail-pen',
  size: 24,
  node: [
    [
      'path',
      {
        d: 'M15.363 17.634a2 2 0 00-.506.854l-.837 2.87a.5.5 0 00.62.62l2.87-.837a2 2 0 00.854-.506l3.013-3.009a1 1 0 10-3.004-3.004z',
        key: '1xvqjp',
      },
    ],
    ['path', { d: 'M22 10.38V6a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h6.25', key: 'nc1zf5' }],
    ['path', { d: 'm22 7-8.991 5.727a2 2 0 01-2.009 0L2 7', key: 'uoxq3m' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name MailPen
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuMzYzIDE3LjYzNGEyIDIgMCAwMC0uNTA2Ljg1NGwtLjgzNyAyLjg3YS41LjUgMCAwMC42Mi42MmwyLjg3LS44MzdhMiAyIDAgMDAuODU0LS41MDZsMy4wMTMtMy4wMDlhMSAxIDAgMTAtMy4wMDQtMy4wMDR6IiAvPgogIDxwYXRoIGQ9Ik0yMiAxMC4zOFY2YTIgMiAwIDAwLTItMkg0YTIgMiAwIDAwLTIgMnYxMmEyIDIgMCAwMDIgMmg2LjI1IiAvPgogIDxwYXRoIGQ9Im0yMiA3LTguOTkxIDUuNzI3YTIgMiAwIDAxLTIuMDA5IDBMMiA3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mail-pen
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MailPen = createLucideIcon(__iconData);

export default MailPen;
